import { Select } from '@pwc/pwc-deals-ui';
import React, { useEffect } from 'react';
import { ErrorAction } from './PowerPointIngestionErrorHandling';
import { useIngestionErrors } from './IngestionErrorProvider';

const PowerPointGroupName = ({
  groupName,
  setGroupName,
  groupNames,
  slideNumber,
  isSlideListLoading,
}) => {
  const [errorState, errorDispatch] = useIngestionErrors();

  const handleGroupNameChange = (value) => {
    errorDispatch(ErrorAction.Clear);
    setGroupName(value);
  };

  const groupNameField = {
    name: 'groupName',
    value: groupName,
    onChange: (event) => handleGroupNameChange(event.target.value),
  };

  useEffect(() => {
    const slideGroupOptions = groupNames[slideNumber];

    if (slideGroupOptions && slideGroupOptions.options.length === 0) {
      if (slideGroupOptions.allOptionsAlreadyIngested) {
        errorDispatch(ErrorAction.NoAvailableGroupsInPowerPointSlideError);
      } else {
        errorDispatch(ErrorAction.NoGroupsInPowerPointSlideError);
      }
    }
  }, [errorDispatch, groupNames, slideNumber]);

  if (isSlideListLoading) {
    return null;
  }

  return (
    <Select
      field={groupNameField}
      label="Group or item name"
      placeholder="Select group or item"
      data-testid="groupName-select"
      disabled={!slideNumber}
      options={groupNames && slideNumber ? groupNames[slideNumber].options : []}
      onChange={(evt) => {
        handleGroupNameChange(evt.target.value);
      }}
      value={groupName}
      error={errorState.groupNameError || errorState.noAvailableGroupsError}
    />
  );
};

export default PowerPointGroupName;
